import styled, { css } from 'styled-components';

export const ButtonStyle = css`
  display: inline-block;
  border: none;
  outline: none;
  background: none;
  cursor: pointer;
  padding: 16px 24px;
  font-size: ${props => props.theme.fonts.sizeButton};
  font-family: ${props => props.theme.fonts.fontfaceRegular};
  font-weight: 200;
  text-decoration: none;
  text-align: center;
  vertical-align: middle;
  letter-spacing: -0.05px;
  width:auto;

  svg {
    width: 24px;
    height: 24px;
    padding: 2px;
  }

  div {
    white-space: nowrap;
  }
  
  ${props =>
    props.primary &&
    css`
      color: ${props => props.theme.colors.white};
      background: ${props => props.theme.colors.primary};
      border: 1px solid ${props => props.theme.colors.primary};
      transition: all 0.2s ease-in-out;

      use {
        fill: ${props => props.theme.colors.white};
      }

      &:hover {
        background: ${props => props.theme.colors.white};
        color: ${props => props.theme.colors.primary};

        use {
          fill: ${props => props.theme.colors.primary};
        }
      }
    `}

    ${props =>
      props.primaryInverted &&
      css`
        color: ${props => props.theme.colors.primary};
        background: ${props => props.theme.colors.white};
        border: 1px solid ${props => props.theme.colors.primary};
        transition: all 0.2s ease-in-out;

        use {
          fill: ${props => props.theme.colors.primary};
        }

        &:hover {
          color: ${props => props.theme.colors.white};
          background: ${props => props.theme.colors.primary};

          use {
            fill: ${props => props.theme.colors.white};
          }
        }
      `}
  ${props =>
    props.secondary &&
    css`
      color: ${props => props.theme.colors.black};
      background: ${props => props.theme.colors.secondary};
      border: 1px solid ${props => props.theme.colors.secondary};
      transition: all 0.2s ease-in-out;

      &:hover {
        background: ${props => props.theme.colors.white};
      }
    `}

    ${props =>
      props.secondaryInverted &&
      css`
        color: ${props => props.theme.colors.secondary};
        background: ${props => props.theme.colors.black};
        border: 1px solid ${props => props.theme.colors.secondary};
        transition: all 0.2s ease-in-out;

        &:hover {
          background: ${props => props.theme.colors.secondary};
          color: ${props => props.theme.colors.black};
        }
      `}
  
  ${props =>
    props.danger &&
    css`
      color: ${props => props.theme.colors.danger};
      background: ${props => props.theme.colors.white};
      border: 1px solid ${props => props.theme.colors.danger};
      transition: all 0.2s ease-in-out;

      use {
        fill: ${props => props.theme.colors.danger};
      }

      &:hover {
        color: ${props => props.theme.colors.white};
        background: ${props => props.theme.colors.danger};

        use {
          fill: ${props => props.theme.colors.white};
        }
      }
    `}

    ${props =>
      props.success &&
      css`
        color: ${props => props.theme.colors.white};
        background: ${props => props.theme.colors.success};
        border: 1px solid ${props => props.theme.colors.success};
        transition: all 0.2s ease-in-out;

        &:hover {
          color: ${props => props.theme.colors.success};
          background: ${props => props.theme.colors.white};
        }
      `}

      ${props =>
        props.inOneLine &&
        css`
          padding: 16px 8px;
          flex: 1 1 15%;
        `}
  
  
   ${props =>
     props.small &&
     css`
       padding: 8px 12px;
     `}

${props =>
  props.cursorAuto &&
  css`
    cursor: auto;
  `}


   ${props =>
     props.xSmall &&
     css`
       padding: 4px 10px;
     `}

  ${props =>
    props.rounded &&
    css`
      border-radius: 5px;
    `}
  ${props =>
    props.absolute &&
    css`
      position: absolute;
    `}
    ${props =>
      props.right &&
      css`
        right: 0;
      `}
  ${props =>
    props.full &&
    css`
      display: block;
      width: 100%;
    `}
  
  ${props =>
    props.disabled &&
    css`
      &,
      &:hover {
        cursor: not-allowed !important;
        background: ${props => props.theme.colors.xDarkgray};
        border: 1px solid ${props => props.theme.colors.xDarkgray};
        color: ${props => props.theme.colors.white}!important;
      }
    `}
    
    ${props =>
      props.$onTitleWithIcon &&
      css`
        padding: 0;
        min-height: 42px;
        position: relative;

        svg {
          width: 50px;
          height: 42px;
          padding: 0;
          position: absolute;
          top: -1px;
          right: -1px;
        }

        span {
          padding: 0 50px 0 18px;
          display: inline-block;
        }
      `}
    `;

const Button = styled.button`
  ${ButtonStyle};
`;
export default Button;
